import SmartTable from "../../../components/smart-table/SmartTable";

const UsersSmartTable = () => {

  return <SmartTable tableId={'users'} urlBase={'users'} />;
  ;
};

export default UsersSmartTable;
